{
  "fixtureId": "79c18f9c-934c-37e8-a4c7-0b3f1928a55d",
  "seasonId": "00000000-0000-4000-8000-000000000101",
  "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
  "groupName": "Tenth Division Group 0002",
  "matchdayId": "5c0507f8-b047-3556-a638-a2ffc7ccea54",
  "matchdayNumber": 12,
  "localMatchdayNumber": 12,
  "startsAt": "2026-11-05T23:00:00Z",
  "endsAt": "2026-11-09T23:00:00Z",
  "status": "PLANNED",
  "matchdayStatus": "PLANNED",
  "venue": "HOME",
  "homeClub": {
    "id": "1b296210-fd7d-5202-a17f-657bd97aec7b",
    "code": "D10-G0002-C01",
    "name": "Burbia F.C.",
    "sponsors": [
      {
        "name": "Nova Sport",
        "logoUrl": "/assets/sponsors/nova_sports_400x160.svg",
        "websiteUrl": null,
        "category": "BILLBOARD"
      },
      {
        "name": "Adidas",
        "logoUrl": "/assets/sponsors/adidas_400x160.svg",
        "websiteUrl": "https://www.adidas.es/",
        "category": "STADIUM"
      },
      {
        "name": "Mercedes Benz",
        "logoUrl": "/assets/sponsors/mercedes_benz_160x160.svg",
        "websiteUrl": "https://www.mercedes-benz.es/",
        "category": "SHIRT"
      }
    ]
  },
  "awayClub": {
    "id": "e0e3de2f-7823-52d2-8ea7-836ea92f458d",
    "code": "D10-G0003-C01",
    "name": "Sporting de Leon",
    "sponsors": [
      {
        "name": "Mercedes Benz",
        "logoUrl": "/assets/sponsors/mercedes_benz_160x160.svg",
        "websiteUrl": "https://www.mercedes-benz.es/",
        "category": "STADIUM"
      },
      {
        "name": "Instalaciones de Pladur Oscar",
        "logoUrl": "/assets/sponsors/pladur_oscar_160x160.svg",
        "websiteUrl": null,
        "category": "SHIRT"
      },
      {
        "name": "Nova Sport",
        "logoUrl": "/assets/sponsors/nova_sports_400x160.svg",
        "websiteUrl": null,
        "category": "BILLBOARD"
      }
    ]
  },
  "stadium": {
    "baseName": "Carqueixal",
    "name": "Adidas Carqueixal",
    "capacity": 60000,
    "ratingLevel": 1.5,
    "facilitiesRatingLevel": 1.5
  },
  "phase": "PLAYOFF",
  "cycleNumber": 1,
  "playoffType": "MAIN"
}
